






















































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
declare let AMap: any;
import trafficPolicyService from "@/service/trafficPolicyService";
// import trafficeService from "@/service/trafficeService";
import * as _ from "lodash";
import orderInfo from "../orderInfo";
import { last, values } from "lodash";
import { OrderStatus } from "@/model/Base";
import trafficService from "@/service/trafficService";
import drivingMap from "@/views/modules/drivingMap.vue";

@Component({
  name: "trafficOrderInfo",
  components: {
    drivingMap,
  },
})
export default class TrafficOrderInfo extends orderInfo {
  @Prop()
  order!: any;

  @Prop()
  InsurancePrice?: any;

  @Prop()
  ChargePrice?: any;

  service = trafficService;
  isShowPriceInfo = false;
  get driverInfo(): { driverName: string; driverLat: string; driverLng: string; driverPhone: string; driverScore: string; vehicleModel: string; vehicleColor: string; vehicleNo: string } {
    let ProductData = this.order.Policys[0].Products[0].ProductData;
    if (!ProductData) {
      return null as any;
    }
    try {
      return JSON.parse(ProductData);
    } catch (error) {
      console.log(error);
      return null as any;
    }
  }

  get departAddress() {
    let lng = this.order.Policys[0].Products[0].ConsumerLongitude * 1;
    let lat = this.order.Policys[0].Products[0].ConsumerLatitude * 1;
    return [lng, lat];
  }
  get arriveAddress() {
    let lng = this.order.Policys[0].Products[0].FinishedLongitude * 1;
    let lat = this.order.Policys[0].Products[0].FinishedLatitude * 1;
    return [lng, lat];
  }
  driverAddress: any[] = [];

  get strAddress() {
    return this.order.Policys[0].Products[0].ConsumerAddress;
  }
  get endAddress() {
    return this.order.Policys[0].Products[0].FinishedAddress;
  }
  get isInService() {
    let featureCodes = this.order.FeatureCodes || "";
    return featureCodes.indexOf("traffic.status.inService") > -1;
  }
  get isDriving() {
    let featureCodes = this.order.FeatureCodes || "";
    return featureCodes.indexOf("traffic.status.inService") > -1 || featureCodes.indexOf("traffic.status.dispatched") > -1;
  }
  get driverStatus() {
    let statusCode = (this.order.FeatureCodes || "").split(/,|;/g).find((s: string) => s.indexOf("traffic.status.") >= 0);
    if (!statusCode) {
      return "unknown";
    }
    let codes = statusCode.split(".");
    if (codes.length < 3) {
      return "unknown";
    }
    return codes[2] || "unknown";
  }

  get driverStatusName() {
    let code: any = {
      unknown: "未知状态",
      inavlid: "无效订单",
      dispatching: "派单中",
      dispatched: "司机已接单",
      driverArrived: "司机到达",
      inService: "行进中",
      endService: "行程结束",
      completed: "已完成",
      priceChange: "价格变更（用户不认可费用，由我我方客服介入判断是否更改价格，另外此状态不出现在详情查询状态）",
      payed: "已支付",
      serving: "订单服务中（等同于-司机已接单/司机已达到/进行中 状态）",
      canceling: "取消中（暂无）",
      canceled: "已取消",
    };
    return code[this.driverStatus];
  }

  routePlans: any[] = [];
  planning(paths: any[]) {
    if (paths && paths.length > 0) {
      this.routePlans = paths;
    }
  }

  mounted() {
    this.initialize();
  }
  initialize() {
    if (this.tickHandle) {
      clearTimeout(this.tickHandle);
    }
    let mapCtl = this.$refs["mapCtl"] as any;
    if (this.isDriving) {
      mapCtl.location();
    } else {
      mapCtl.clearMap();

      mapCtl.createOverMarker({ position: this.departAddress }, { path: require("../../../../static/img/qidian.png") });
      mapCtl.createOverMarker({ position: this.arriveAddress }, { path: require("../../../../static/img/zhongdi.png") });
      mapCtl.createOverText(this.strAddress, this.departAddress);
      mapCtl.createOverText(this.endAddress, this.arriveAddress);
      mapCtl.fitView();
    }
    this.syncDriver();
    this.syncStatus();
  }

  @Watch("Order")
  orderChange() {
    this.initialize();
  }

  tickHandle?: number;
  syncDriver() {
    let speed = 1000 * 10;
    if ("dispatching,driverArrived".indexOf(this.driverStatus) > -1) {
      speed = 1000 * 5;
    } else if ("dispatched,inService".indexOf(this.driverStatus) > -1) {
      speed = 1000;
    } else if ("endService,completed,canceling,canceled".indexOf(this.driverStatus) > -1) {
      return;
    }
    if (this.isDriving) {
      this.queryDriver().then(() => (this.tickHandle = setTimeout(this.syncDriver, speed)));
    } else {
      this.tickHandle = setTimeout(this.syncDriver, speed);
    }
  }
  syncStatus() {
    // inavlid: "无效订单",
    // dispatching: "派单中",
    // dispatched: "司机已接单",
    // driverArrived: "司机到达",
    // inService: "行进中",
    // endService: "行程结束",
    // completed: "已完成",
    // priceChange: "价格变更（用户不认可费用，由我我方客服介入判断是否更改价格，另外此状态不出现在详情查询状态）",
    // payed: "已支付",
    // serving: "订单服务中（等同于-司机已接单/司机已达到/进行中 状态）",
    // canceling: "取消中（暂无）",
    // canceled: "已取消",

    let speed = 1000 * 10;
    if ("dispatching".indexOf(this.driverStatus) > -1) {
      speed = 1000;
    } else if ("dispatched,driverArrived,inService".indexOf(this.driverStatus) > -1) {
      speed = 1000 * 5;
    } else if ("endService,completed,canceling,canceled".indexOf(this.driverStatus) > -1) {
      return;
    } else {
      this.tickHandle = setTimeout(this.syncStatus, speed);
      return;
    }
    this.simpleOrder().then(() => (this.tickHandle = setTimeout(this.syncStatus, speed)));
  }
  simpleOrder() {
    return trafficService.GetSimpleOrder(this.order.UniqueID).then(json => {
      let result: any = json.result;
      if (result.ClientOrderStatus != this.order.ClientOrderStatus || result.FeatureCodes != this.order.FeatureCodes) {
        console.log(`${result.ClientOrderStatus} != ${this.order.ClientOrderStatus}  ${result.FeatureCodes} != ${this.order.FeatureCodes}`);
        this.$emit("reload");
      }
    });
  }

  destroyed() {
    if (this.tickHandle) {
      clearTimeout(this.tickHandle);
    }
  }

  driverLocations: any[] = [];
  get mapCtl(): any {
    return this.$refs.mapCtl;
  }

  carMarker: any;
  userMarker: any;

  changeCount = 0;
  //司机位置变动
  driverAddressChange() {
    //等车中：司机位置~出发位置  服务中：司机位置~到达位置
    let intentAddress = this.isInService ? this.departAddress : this.arriveAddress;

    this.mapCtl.planning(this.driverAddress, intentAddress);

    let mapCtl = this.mapCtl;
    if (!this.carMarker) {
      this.carMarker = mapCtl.createOverMarker(
        { position: this.driverAddress, autoRotation: true, angle: -90 },
        {
          path: "https://webapi.amap.com/images/car.png",
          size: { width: 40, height: 50 },
          width: 30,
          height: 20,
        },
        { x: -26, y: -10 }
      );
    }
    if (!this.userMarker) {
      this.userMarker = mapCtl.createOverMarker({ position: this.departAddress }, { path: "https://a.amap.com/jsapi_demos/static/resource/img/user.png", width: 25, height: 25 });
    }
    let paths = [];
    for (let i = this.driverLocations.length - 2; i < this.driverLocations.length; i++) {
      let location = this.driverLocations[i];
      if (location && location.Latitude && location.Longitude) {
        paths.push([location.Latitude, location.Longitude]);
      }
    }
    this.carMarker.moveAlong(paths, 100);
    this.changeCount++;
    if (this.changeCount % 20 == 0) {
      mapCtl.fitView();
    }
  }
  // 获取司机位置
  queryDriver() {
    let lastIndex = 0;
    if (this.driverLocations.length > 0) {
      lastIndex = this.driverLocations[this.driverLocations.length - 1].Index || 0;
    }
    //从服务端获取司机位置
    return trafficPolicyService.queryDriver(this.order.UniqueID, lastIndex).then(res => {
      if (!res.isSucc || !res.result || res.result.length == 0) {
        return;
      }
      let locations = res.result;
      locations.forEach(o => this.driverLocations.push(o));
      let location = locations[locations.length - 1];
      this.driverAddress = [location.Latitude, location.Longitude];
      this.driverAddressChange();
    });
  }

  call(phone: string) {
    window.location.href = `tel://${phone}`;
  }
}
